unit UCommonConfig;

interface

type
  TCommonConfig = class
  private
    FDecimalValues: Boolean;
    FWorkOrderTimes: Boolean;
    FAppReset: Integer;
    FUseKst: Boolean;
    FPrimaryPage: Integer;
    FGeoLoaction: Boolean;
    procedure ClearValues;
    procedure SetValues(json: string);
    procedure SetDecimalValues(const Value: Boolean);
    procedure SetWorkOrderTimes(const Value: Boolean);
    procedure SetAppReset(const Value: Integer);
    procedure SetUseKst(const Value: Boolean);
    procedure SetPrimaryPage(const Value: Integer);
    procedure SetGeoLoaction(const Value: Boolean);
  public
    constructor Create; overload;
    constructor Create(json: string); overload;
    property DecimalValues: Boolean read FDecimalValues write SetDecimalValues;
    property WorkOrderTimes: Boolean read FWorkOrderTimes
      write SetWorkOrderTimes;
    property AppReset: Integer read FAppReset write SetAppReset;
    property UseKst: Boolean read FUseKst write SetUseKst;
    property PrimaryPage: Integer read FPrimaryPage write SetPrimaryPage;
    property GeoLoaction: Boolean read FGeoLoaction write SetGeoLoaction;
  end;

implementation

uses
  Js, UEssentialHelper, System.SysUtils;

{ TCommonConfig }

procedure TCommonConfig.ClearValues;
begin
  Self.DecimalValues := false;
  Self.WorkOrderTimes := false;
  Self.AppReset := 0;
  Self.UseKst := false;
  Self.PrimaryPage := 0;
  Self.GeoLoaction := false;
end;

constructor TCommonConfig.Create(json: string);
begin
  Self.SetValues(json);
end;

constructor TCommonConfig.Create;
begin
  Self.ClearValues;
end;

procedure TCommonConfig.SetAppReset(const Value: Integer);
begin
  FAppReset := Value;
end;

procedure TCommonConfig.SetDecimalValues(const Value: Boolean);
begin
  FDecimalValues := Value;
end;

procedure TCommonConfig.SetGeoLoaction(const Value: Boolean);
begin
  FGeoLoaction := Value;
end;

procedure TCommonConfig.SetPrimaryPage(const Value: Integer);
begin
  FPrimaryPage := Value;
end;

procedure TCommonConfig.SetUseKst(const Value: Boolean);
begin
  FUseKst := Value;
end;

procedure TCommonConfig.SetValues(json: string);
var
  obj: TJsObject;
begin
  Self.ClearValues;
  obj := TJsJson.parseObject(json);
  if obj['DecimalValues'] <> nil then
    Self.DecimalValues := StrToBoolean(string(obj['DecimalValues']));
  if obj['WorkOrderTimes'] <> nil then
    Self.WorkOrderTimes := StrToBoolean(string(obj['WorkOrderTimes']));
  if obj['AppReset'] <> nil then
    Self.AppReset := StrToInt(string(obj['AppReset']));
  if obj['UseKst'] <> nil then
    Self.UseKst := StrToBoolean(string(obj['UseKst']));
  if obj['PrimaryPage'] <> nil then
    Self.PrimaryPage := StrToInt(string(obj['PrimaryPage']));
  if obj['GeoLocation'] <> nil then
    Self.GeoLoaction := StrToBoolean(string(obj['GeoLocation']));
end;

procedure TCommonConfig.SetWorkOrderTimes(const Value: Boolean);
begin
  FWorkOrderTimes := Value;
end;

end.
